import React, { useState } from 'react';
import Layout from '../components/Layout';
import WebsiteTemplates from '../components/WebsiteTemplates';
import ClientWebsites from '../components/ClientWebsites';

const Websites: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'client' | 'templates'>('client');

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Website Management</h1>
        </div>

        {/* Tab navigation */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab('client')}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'client'
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Client Websites
            </button>
            <button
              onClick={() => setActiveTab('templates')}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'templates'
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Templates
            </button>
          </nav>
        </div>

        {/* Tab content */}
        <div className="bg-white rounded-lg shadow p-6">
          {activeTab === 'client' ? <ClientWebsites /> : <WebsiteTemplates />}
        </div>
      </div>
    </Layout>
  );
};

export default Websites; 